import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-10 pb-6">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">

        {/* Redes sociales */}

         <div className="flex flex-col items-start">
          <h2 className="text-lg font-semibold mb-4">Síguenos</h2>


           <div className="flex flex-col space-y-3 text-xl w-full">
            <Link to="#" aria-label="Instagram" className="hover:text-gray-400 flex items-center gap-3 w-full">
              <i className="fab fa-instagram w-6 text-center"></i>
              <span>Instagram</span>
            </Link>

            <Link to="#" aria-label="YouTube" className="hover:text-gray-400 flex items-center gap-3 w-full">
              <i className="fab fa-youtube w-6 text-center"></i>
              <span>YouTube</span>
            </Link>

            <Link to="#" aria-label="LinkedIn" className="hover:text-gray-400 flex items-center gap-3 w-full">
              <i className="fab fa-linkedin w-6 text-center"></i>
              <span>LinkedIn</span>

            </Link>
          </div>
        </div>

        {/* Sección 1 */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Empresa</h2>
          <ul className="space-y-2 text-sm">
            <li><Link to="/nosotros" className="hover:text-gray-400">Nosotros</Link></li>
            <li><Link to="/camiones" className="hover:text-gray-400">Camiones</Link></li>
            <li><Link to="/trabajadores" className="hover:text-gray-400">Trabajadores</Link></li>
            <li><Link to="/empresas" className="hover:text-gray-400">Empresas</Link></li>
            <li><Link to="/trabaja-con-nosotros" className="hover:text-gray-400">Trabaja con Nosotros</Link></li>
          </ul>
        </div>

        {/* Sección 2 */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Servicios</h2>
          <ul className="space-y-2 text-sm">
            <li><Link to="/seguros" className="hover:text-gray-400">Seguros</Link></li>
            <li><Link to="/metodospagos" className="hover:text-gray-400">Métodos de pagos</Link></li>
            <li><Link to="/resenas" className="hover:text-gray-400">Reseñas</Link></li>
            <li><Link to="/cotizaciones" className="hover:text-gray-400">Cotiza</Link></li>
            <li><Link to="/seguimiento" className="hover:text-gray-400">Seguimiento</Link></li>
          </ul>
        </div>

        {/* Sección 3 */}
        <div>
          <h2 className="text-lg font-semibold mb-4">Ayuda</h2>
          <ul className="space-y-2 text-sm">
            <li><Link to="/embalaje" className="hover:text-gray-400">Embalaje</Link></li>
            <li><Link to="/perfil" className="hover:text-gray-400">Perfil</Link></li>
            <li><Link to="/contact" className="hover:text-gray-400">Contáctanos</Link></li>
            <li><Link to="/preguntas" className="hover:text-gray-400">Preguntas Frecuentes</Link></li>
          </ul>
        </div>
      </div>

      {/* Línea inferior */}
      <div className="mt-10 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} FRABAS Mudanzas. Todos los derechos reservados.
      </div>
    </footer>
  );
};

export default Footer;
